import { Fragment } from "react";
import { Button, Col } from "reactstrap";
import { AppStore, AvailableOnThe, GooglePlay, Href } from "../../../Constants/Constants";
import { FooterData } from "../../../Data/Layout/Footer";
import { Link } from "react-router-dom";

const FooterMenu = () => {
  return (
    <Fragment>
      {FooterData.map((item, index) => (
        <Col lg="2" md="3" sm="6" key={index}>
          <div className="links">
            <div className="footer-title">
              <h3>{item.title}</h3>
            </div>
            <div className="footer-contant">
              <ul>
                {item.links.map((link, i) => (
                  <li key={i}><Link to={link.url}>{link.text}</Link></li>
                ))}
              </ul>
            </div>
          </div>
        </Col>
      ))}
      <Col lg="3" md="4" sm="6">
        <div className="downlaod">
          <div>
            <div className="footer-title mb-3"><h2>Download Apps</h2></div>
            <div className="footer-contant1">
              <div className="footer-btn">
                <Button tag={"a"} color="transparent" active href={Href}>
                  <i className="fa fa-apple" />
                  <div>
                    <h6>{AvailableOnThe}</h6>
                    <h4>{AppStore}</h4>
                  </div>
                </Button>
                <Button tag={"a"} color="transparent" href={Href}>
                  <i className="fa fa-play" />
                  <div>
                    <h6>{AvailableOnThe}</h6>
                    <h4>{GooglePlay}</h4>
                  </div>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </Fragment>
  );
};

export default FooterMenu;
